import {
  DocumentBirthFormVM,
  DocumentBirthUploadFormVM,
  DocumentCivilUnionUploadFormVM,
  DocumentDeathUploadFormVM,
  DocumentMarriageFormVM,
  DocumentMarriageUploadFormVM,
} from 'civil-status/view-models/document-birth-form';
import { transformDocumentBirthRequestUpdate } from 'civil-status/utils/transform-document-birth';
import {
  BirthAct,
  DeathAct,
  RequestUploadSimaNewAct,
  UnionAct,
} from 'civil-status/model/sima-new-act';
import { transformDocumentMarriageRequestUpdate } from './transform-document-marriage';
import { transformDocumentCivilUnionRequest } from './transform-document-civil-union';
import { CitizenshipAct } from 'civil-status/model/sima-new-act';
import { DocumentCitizenshipUploadFormVM } from 'civil-status/view-models/document-citizenship-form';
import { transformCitizenshipRequest } from './transform-document-citizenship';
import { transformDocumentDeathRequestUpdate } from './transform-document-death';

export const transformUploadBirthNewPage = (
  form?: DocumentBirthUploadFormVM
): RequestUploadSimaNewAct | undefined => {
  const transformedBirth = transformDocumentBirthRequestUpdate(
    form as DocumentBirthFormVM
  ) as unknown as BirthAct;
  return {
    simaNascita: transformedBirth,
    filename: form?.upload?.file?.name,
    mimeType: form?.upload?.file?.type,
    file: form?.upload?.rawTiff?.split(',')[1],
  };
};

export const transformUploadMarriageNewPage = (
  form?: DocumentMarriageUploadFormVM
): RequestUploadSimaNewAct | undefined => {
  const transformed = transformDocumentMarriageRequestUpdate(
    form as DocumentMarriageFormVM
  ) as unknown as UnionAct;
  return {
    modificaAttoSimaMatrimonioRichiesta: transformed,
    filename: form?.upload?.file?.name,
    mimeType: form?.upload?.file?.type,
    file: form?.upload?.rawTiff?.split(',')[1],
  };
};

export const transformUploadCivilUnionNewPage = (
  form?: DocumentCivilUnionUploadFormVM
): RequestUploadSimaNewAct | undefined => {
  const transformed = transformDocumentCivilUnionRequest(
    form as DocumentCivilUnionUploadFormVM
  ) as unknown as UnionAct;
  return {
    modificaAttoSimaUnioneCivileRichiesta: transformed,
    filename: form?.upload?.file?.name,
    mimeType: form?.upload?.file?.type,
    file: form?.upload?.rawTiff?.split(',')[1],
  };
};

export const transformUploadCitizenshipNewPage = (
  form?: DocumentCitizenshipUploadFormVM
): RequestUploadSimaNewAct | undefined => {
  const transformed = transformCitizenshipRequest(
    form as DocumentCitizenshipUploadFormVM
  ) as unknown as CitizenshipAct;
  return {
    simaCittadinanza: transformed,
    filename: form?.upload?.file?.name,
    mimeType: form?.upload?.file?.type,
    file: form?.upload?.rawTiff?.split(',')[1],
  };
};

export const transformUploadDeathNewPage = (
  form?: DocumentDeathUploadFormVM
): RequestUploadSimaNewAct | undefined => {
  const transformed = transformDocumentDeathRequestUpdate(
    form as DocumentDeathUploadFormVM
  ) as unknown as DeathAct;
  return {
    simaMorte: transformed,
    filename: form?.upload?.file?.name,
    mimeType: form?.upload?.file?.type,
    file: form?.upload?.rawTiff?.split(',')[1],
  };
};
